const money = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 2 });

export const fmtMoney = (v) => (v === null || v === undefined || Number.isNaN(Number(v)) ? '—' : money.format(Number(v)));

export const timeAgo = (iso) => {
  if (!iso) return 'nunca';
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'hace instantes';
  if (s < 3600) return `hace ${Math.round(s / 60)} min`;
  if (s < 86400) return `hace ${Math.round(s / 3600)} h`;
  return `hace ${Math.round(s / 86400)} d`;
};

export const fmtFecha = (iso) => (iso ? new Date(iso).toLocaleString('es-AR', {
  day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
}) : '—');

export const INTERVALOS = [
  { v: 5, l: 'Cada 5 min' }, { v: 10, l: 'Cada 10 min' }, { v: 15, l: 'Cada 15 min' },
  { v: 30, l: 'Cada 30 min' }, { v: 60, l: 'Cada 1 hora' }, { v: 120, l: 'Cada 2 horas' },
  { v: 240, l: 'Cada 4 horas' }, { v: 480, l: 'Cada 8 horas' }, { v: 720, l: 'Cada 12 horas' },
  { v: 1440, l: 'Una vez por día' },
];

export const intervaloLabel = (m) => INTERVALOS.find((i) => i.v === m)?.l || `Cada ${m} min`;

export const iniciales = (nombre) => (nombre || '?').split(/\s+/).filter(Boolean).slice(0, 2)
  .map((p) => p[0]).join('').toUpperCase();

export const REGLAS_DEFAULT = {
  diario: { monto: '', pct: '20' },
  mensual: { monto: '', pct: '20' },
  saldo: { monto: '', pct: '' },
};

const num = (s) => (s === '' || s === null || s === undefined ? null : Number(s));

export const reglasToApi = (r) => Object.fromEntries(
  Object.entries(r).map(([k, u]) => [k, { monto: num(u.monto), pct: num(u.pct) }]),
);

export const reglasFromApi = (r) => Object.fromEntries(
  ['diario', 'mensual', 'saldo'].map((k) => [k, {
    monto: r?.[k]?.monto ?? '', pct: r?.[k]?.pct ?? '',
  }]),
);

export const toNum = num;

export const MAX_ETIQUETAS = 3;

const ETQ_COLORES = [
  'bg-sky-50 text-sky-800 border-sky-200', 'bg-amber-50 text-amber-800 border-amber-200',
  'bg-violet-50 text-violet-800 border-violet-200', 'bg-emerald-50 text-emerald-800 border-emerald-200',
  'bg-rose-50 text-rose-800 border-rose-200', 'bg-orange-50 text-orange-800 border-orange-200',
  'bg-cyan-50 text-cyan-800 border-cyan-200', 'bg-slate-100 text-slate-700 border-slate-300',
];

export const etiquetaColor = (t) => {
  let h = 0;
  for (const c of (t || '').toLowerCase()) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return ETQ_COLORES[h % ETQ_COLORES.length];
};

export const normEtiqueta = (t) => (t || '').replace(/\s+/g, ' ').trim().slice(0, 30);

export const mismaEtiqueta = (a, b) => (a || '').toLowerCase() === (b || '').toLowerCase();
